import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import buildQuery from "odata-query";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Router } from "@angular/router";
import { CDILinesDto } from "../../../core/models/cdi/CDILinesDto";
import { VendorInvoiceJournalDetailValue } from "../../../core/models/orders/vendorInvoiceJournalDetailValue";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { OrderLineItemComponent } from "../../orders/components/order-line-item/order-line-item.component";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";

@UntilDestroy()
@Component({
  selector: "jni-cdi-lines",
  templateUrl: "./cdi-lines.component.html",
  styleUrls: ["./cdi-lines.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    OrderLineItemComponent,
    ModalStackerComponent,
  ],
})
export class CdiLinesComponent {
  @Input() cdiLinesGridListing: CDILinesDto[] = [];
  @Input() OrderLineId = "";
  @Input() saleOrderModalStatus = true;
  @Input() inputPoNumber = "";

  @Output() gridRefresh = new EventEmitter<boolean>();
  @Output() copyLinesEvent = new EventEmitter<CDILinesDto[]>();
  @Output() updateLine = new EventEmitter();
  @Output() refrestDataEvent = new EventEmitter();
  @Output() gridSaveAndUpdateEvent = new EventEmitter<CDILinesDto>();
  @Output() changeDetect = new EventEmitter<boolean>();
  @Output() scrollHiddenStatus = new EventEmitter();

  selectedCDILine: CDILinesDto[] = [];
  showSmallLoader = false;
  count = 1;
  orderLineDisplayModal = false;
  orderLineNumber = 0;

  @ViewChild("dt") table!: Table;
  // @ViewChild('copyline', { static: false })
  // copyline!: CopyLinesComponent;

  percentageSign = "%";
  unmatchQuantityStatus = false;
  vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  displayModal = false;
  selectionMode = "";

  editItem!: CDILinesDto;

  constructor(
    private _router: Router,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _orderSummary: OrderSummaryService
  ) {}

  //hideDeleteLineButton() {
  //   if (this.selectedCDILine.length > 0) {
  //     for (const item of this.selectedCDILine) {
  //       if (
  //         item.salesOrderLine?.lineStatusD365?.toLowerCase() === 'delivered'
  //       ) {
  //         this.deleteButtonStatus = true;
  //         return;
  //       } else {
  //         this.deleteButtonStatus = false;
  //       }
  //     }
  //   } else {
  //     this.deleteButtonStatus = false;
  //   }
  //}

  getOddEvenNumber(lineNumber: number) {
    if (lineNumber % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  editLine(id: number) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.id === id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  //refreshGrid() {
  //this.gridRefresh.emit();
  //}

  onRowEditSave(cdiLine: CDILinesDto) {
    if (!cdiLine.net) {
      this._toastr.error("Error", "Net amount required");
      this.refrestDataEvent.emit();
      return;
    }
    if (!cdiLine.sell) {
      this._toastr.error("Error", "Sell amount required");
      this.refrestDataEvent.emit();
      return;
    }
    if (!cdiLine.qty) {
      this._toastr.error("Error", "Quantity required");
      this.refrestDataEvent.emit();
      return;
    }

    if (!cdiLine.id) {
      this.gridSaveAndUpdateEvent.emit(cdiLine);
    } else {
      this.gridSaveAndUpdateEvent.emit(cdiLine);
    }
  }

  onRowEditInit(event: CDILinesDto) {
    this.editItem = event;
  }

  onRowEditCancel(event: CDILinesDto) {
    this.editItem = event;
    this.refrestDataEvent.emit();
  }

  addNewLine() {
    const sortedTable = this.table.value.sort((a, b) => {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    });
    const lastObject = sortedTable[sortedTable?.length - 1];
    if (lastObject) {
      const lineObject = {
        id: lastObject.id + 1,
        vendorSku: lastObject.vendorSku,
        description: "",
        unmatch: "",
        qty: "",
        net: "",
        netTotal: "",
        sell: "",
        sellTotal: "",
        netGp: "",
        notes: [],
      } as unknown as CDILinesDto;
      this.cdiLinesGridListing.push(lineObject);
    } else {
      const lineObject = {
        id: 1,
        vendorSku: "",
        description: "",
        unmatch: "",
        qty: "",
        net: false,
        netTotal: "",
        sell: "",
        sellTotal: "",
        netGp: "",
        notes: [],
      } as unknown as CDILinesDto;
      this.cdiLinesGridListing.push(lineObject);
    }

    this.table.initRowEdit(this.table.value[this.table.value?.length - 1]);
  }

  onCopyLines() {
    const SelectedPoLines = this.selectedCDILine;
    this.selectedCDILine = [];
    this.copyLinesEvent.emit(SelectedPoLines);
  }

  onLineRedirect() {
    this.updateLine.emit();
  }

  uncheckAll() {
    this.selectedCDILine = [];
  }

  openUrlDialog(poNumber: string) {
    if (poNumber) {
      const filter = {
        PurchId: poNumber,
      };
      const query = buildQuery({ filter });

      this.vendorInvoiceJournalDetail = [];
      this._loaderService.setLoaderState(true);
      this._orderSummary
        .getUnmatchQuantityUrl(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (res.data.length > 0) {
                this.vendorInvoiceJournalDetail = res.data;
                if (this.vendorInvoiceJournalDetail.length === 1) {
                  const url =
                    this.vendorInvoiceJournalDetail[0].DocumentURL || "";
                  window.open(url, "_blank");
                } else {
                  this.unmatchQuantityStatus = true;
                }
              } else {
                this._toastr.error("Error", "Record not found");
              }
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Record not found");
          },
        });
    } else {
      this._toastr.error("Error", "PO Number is required");
    }
  }

  closeUrlDialog() {
    this.unmatchQuantityStatus = false;
  }

  showModalDialog() {
    if (this.selectedCDILine && this.selectedCDILine?.length > 0) {
      this.copyLineItems();
    } else {
      //this.displayModal = true;
      //this.selectionMode = 'Multiple';
      //this.copyline.getAllCDILines();
      this.onCopyLines();
    }
  }

  closeModalDialog() {
    this.displayModal = false;
  }

  copyLineItems() {
    this._loaderService.setLoaderState(true);

    // const copyLineArray: AddUpdateCdiLineDto = {
    //   cdiLine: this.selectedCDILine
    // };

    this.selectedCDILine.forEach(x =>
      this.cdiLinesGridListing.push({
        id:
          this.selectedCDILine[this.selectedCDILine.length - 1].id +
          this.count++,
        poNumber: x.poNumber,
        vendorSku: x.vendorSku,
        description: x.description,
        deliverRemainderD365: x.deliverRemainderD365,
        orderedPurchaseQuantityD365: x.orderedPurchaseQuantityD365,
        unmatch: x.unmatch,
        qty: x.qty,
        net: x.net,
        netTotal: x.netTotal,
        sell: x.sell,
        sellTotal: x.sellTotal,
        netGp: x.netGp,
        status: x.status,
        notes: x.notes,
      })
    );

    this.selectedCDILine = [];

    // this._cdiSummaryService
    //   .addCdiLine(copyLineArray)
    //   .pipe(untilDestroyed(this))
    //   .subscribe({
    //     next: (res) => {
    //       this._loaderService.setLoaderState(false);

    //       if (res.data) {
    //         this.changeDetect.emit(true);
    //         this._toastr.success('Success', res.message);
    //       } else {
    //         this._toastr.error(
    //           'Error',
    //           res.message || 'Error adding line item'
    //         );
    //       }
    //     },
    //     error: (res) => {
    //       this._loaderService.setLoaderState(false);
    //       this._toastr.error('Error', res.message || 'Error adding line item');
    //     }
    //   });

    this._loaderService.setLoaderState(false);
  }

  redirectToLineItem() {
    if (this.OrderLineId) {
      if (this.saleOrderModalStatus) {
        this.orderLineNumber = 0;
        this.orderLineDisplayModal = true;
      } else {
        this.orderLineDisplayModal = false;
        this._router.navigate(["/orders/order-line-item/" + this.OrderLineId]);
      }
    }
  }

  closeModal() {
    this.orderLineDisplayModal = false;
    this.gridRefresh.emit();
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }
}
